// Vendor
import { combineReducers } from '@ngrx/store';
// Reducer
import { modelPortfolioToPushToIRebal } from './state/model-portfolio-to-push-to-irebal/model-portfolio-to-push-to-irebal.reducer';
export const IREBAL_PUSH_MODAL_STATE_SLICE_KEY = 'iRebalPushModal';
export const irebalPushModal = combineReducers({
    modelPortfolioToPushToIRebal,
});
